const i18n = require("./i18n.json");
const { allFeatureFlags, environments } = require("../../environments");

module.exports = {
  i18n,
  allFeatureFlags,
  environments
};
